import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../app/store';
import { TranslationsPayload } from '../models/translations';

export interface translationsState {
    fetchTranslationStatus: string;
    translations: Array<TranslationsPayload>;
}

const initialState: translationsState = {
    fetchTranslationStatus : "",
    translations: []
};

const translationsSlice = createSlice({
  name: 'translations',
  initialState,
  reducers: {
    translationList(state, action: PayloadAction<any>) {
        state.fetchTranslationStatus = "pending";
    },
    translationsListSuccess(state, action: PayloadAction<any>) {
        state.translations = action?.payload?.results ?? [];
        state.fetchTranslationStatus = "success";
    },
    translationsListFailed(state, action: PayloadAction<string>) {
        state.fetchTranslationStatus = "failed";
    },
    resetTranslations(state) {
        state.fetchTranslationStatus = "";
        state.translations = [];
    }
  }
});

// Actions
export const translationActions = translationsSlice.actions;

// Selectors
export const fetchTranslations = (state: RootState) => state.translations.translations;
export const fetchTranslationStatus=(state:RootState)=>state.translations.fetchTranslationStatus
// Reducer
const translationsReducer = translationsSlice.reducer;
export default translationsReducer;
